<template>
    <van-dialog
        v-model="show"
        :title="$t('transfer.noticeTitle')"
        theme="round-button"
        :confirm-button-text="$t('common.confirm')"
        confirm-button-color="#e4004f"
        get-container="#login-wrapper"
        @confirm="handleConfirm"
    >
        <div class="content">
            <van-checkbox v-model="agreed" shape="square" checked-color="#e4004f" icon-size="16" />
            {{ $t('transfer.noticeContent') }}
        </div>
    </van-dialog>
</template>

<script>
/* eslint-disable object-curly-newline */
import Vue from 'vue';
import { Dialog, Checkbox } from 'vant';
import clone from 'lodash/clone';
import { Platform, RegionId } from '@/enums';

Vue.use(Checkbox);

export default {
    components: { [Dialog.Component.name]: Dialog.Component },
    data() {
        return {
            show: true,
            agreed: true,
            form: {
                success: {},
                error: [],
            },
        };
    },
    created() {
        this.parametersValidator()
            .then(data => {
                const { appId, platform, ...accountInfo } = data;
                sessionStorage.setItem('accountInfo', JSON.stringify(accountInfo));
                this.form.success = data;
            })
            .catch(error => {
                error.forEach(key => {
                    this.$toast(`${key} parameter is required`);
                });
                this.form.error = error;
            });
    },
    methods: {
        // 大无语事件：WebView 过来的 gameid、channelid、encodeparam 都是小写，需要兼容 (*｀皿´*)ﾉ
        getLIparameters() {
            const query = clone(this.$route.query);
            if ('gameid' in query) {
                query.gameId = query.gameid;
                delete query.gameid;
            }
            if ('channelid' in query) {
                query.channelId = query.channelid;
                delete query.channelid;
            }
            if ('encodeparam' in query) {
                query.encodeParam = query.encodeparam;
                delete query.encodeparam;
            }
            return query;
        },
        parametersValidator() {
            const result = {
                success: this.getLIparameters(),
                error: [],
            };

            // 校验必传参数
            const { appId, channelId, platform, openId, token, encodeParam, regionId } =
                result.success;
            if (!appId) result.error.push('appId');
            if (!channelId) result.error.push('channelId');
            if (!regionId) result.error.push('regionId');
            if (!platform) {
                result.error.push('platform');
            } else if (+platform === Platform.H5Transfer && !openId) {
                result.error.push('openId');
            } else if (+platform === Platform.H5Transfer && !token) {
                result.error.push('token');
            } else if (+platform === Platform.WebViewTransfer && !encodeParam) {
                result.error.push('encodeParam');
            } else {
                result.success.platform = +platform;
            }

            return new Promise((resolve, reject) => {
                if (result.error.length) {
                    result.success = {};
                    reject(result.error);
                } else {
                    resolve(result.success);
                }
            });
        },
        handleConfirm() {
            if (this.agreed) return this.$emit('on-confirm', this.form.success);
            const { regionId, appId, platform } = this.$route.query;
            this.$router.push({
                name: 'tencentLiPass',
                params: { region: RegionId[+regionId] },
                query: {
                    appId,
                    platform,
                },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.van-overlay + .van-dialog {
    position: absolute;
}

.content {
    white-space: pre-wrap;
    font-size: 14px;
    line-height: 20px;
    padding: 16px 16px;
    color: #333333;
}

.van-checkbox {
    display: inline-flex;

    /deep/ .van-icon {
        border-radius: 4px;
    }
}

.van-dialog--round-button /deep/.van-goods-action button {
    border-radius: 8px;
}
</style>
